import styled from '@emotion/styled';

export const PillFrame = styled.span`
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
`;

export const PillButtonFrame = styled.button`
  appearance: none;
  display: inline-flex;
  align-items: center;
  border: 0;
  border-radius: 999px;
  background: transparent;
  font: inherit;
`;
